import { State } from "./state";
import { GetterTree } from "vuex";

const getFilter = (state: State) => {
  return state.filter;
};
export default <GetterTree<State, any>>{
  getFilter,
};
